import { render, staticRenderFns } from "./JangkaPendekViewNew.vue?vue&type=template&id=61384fce&scoped=true&lang=pug&"
import script from "./JangkaPendekViewNew.vue?vue&type=script&lang=js&"
export * from "./JangkaPendekViewNew.vue?vue&type=script&lang=js&"
import style0 from "./JangkaPendekViewNew.vue?vue&type=style&index=0&id=61384fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61384fce",
  null
  
)

export default component.exports